module.exports = __webpack_public_path__ + "static/media/hwuk_logo.96479621.svg";